<div class="hw-box-content">
  <div class="hw-header-wrap">
    <div class="row">
      <div class="col-6">
        <i class="fn-global-site"></i>
        Alert Compare
      </div>
    </div>
  </div>
  <div class="hw-title">
    <div class="row">
      <div class="col-6">
        <ul class="list-inline">
          <li class="align-top width-210px">
            <fn-select
              [labelKey]="'name'"
              [inputKey]="'url'"
              [optionList]="envArray"
              [placeholder]="'Select Environment'"
              [(ngModel)]="selectEnv"
              appendTo="body"
              [ngModelOptions]="{ standalone: true }"
            >
            </fn-select>
          </li>
        </ul>
      </div>
    </div>
  </div>
  @if(selectEnv){
  <div class="hw-content">
    <div class="row">
      <label class="col-6 margin-bottom-10"
        ><strong> This Environment Alert</strong></label
      >
      <label class="col-4 margin-bottom-10"
        ><strong> {{ environment }} Alert</strong></label
      >
      <div class="col-2 margin-bottom-10" style="z-index: 0">
        <label>
          <fn-table-search
            (search)="searchOnRows($event)"
            (closeSearch)="closeSearch()"
          >
          </fn-table-search>
        </label>
      </div>
      <div class="col-6">
        <div class="table-container">
          <table class="table table-bordered fixed-layout m-0">
            <colgroup>
              <col style="width: 50%" />
              <col style="width: 40%" />
              <col style="width: 10%" />
            </colgroup>
            <thead>
              <tr>
                <th class="text-center">IdenNo</th>
                <th class="text-center">Product Name</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of firstPagedData; let i = index">
                <td class="text-center text-truncate" title="{{ row.idenNo }}">
                  {{ row.idenNo }}
                </td>
                <td
                  class="text-center text-truncate"
                  title="{{ row.productName }}"
                >
                  {{ row.productName }}
                </td>
                <td class="text-center">
                  <i
                    class="fn-global-rightArrow-fill blue cursor-pointer mr-5"
                    (click)="alertMoveFirstEnv(row)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-12">
            <fn-pagination
              class="escalation-pagination"
              [currentPage]="firstPagination.currentPage"
              [totalPage]="firstPagination.totalSize"
              [pageSize]="firstPagination.pageSize"
              (changePage)="onFirstPageChange($event)"
            ></fn-pagination>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="table-container">
          <table class="table table-bordered fixed-layout m-0">
            <colgroup>
              <col style="width: 50%" />
              <col style="width: 40%" />
              <col style="width: 10%" />
            </colgroup>
            <thead>
              <tr>
                <th class="text-center">IdenNo</th>
                <th class="text-center">Product Name</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of secondPagedData; let i = index">
                <td class="text-center text-truncate" title="{{ row.idenNo }}">
                  {{ row.idenNo }}
                </td>
                <td
                  class="text-center text-truncate"
                  title="{{ row.productName }}"
                >
                  {{ row.productName }}
                </td>
                <td class="text-center">
                  <i
                    class="fn-global-rightArrow-fill blue cursor-pointer rotate-180"
                    (click)="alertMoveSecondEnv(row)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-12">
            <fn-pagination
              class="escalation-pagination"
              [currentPage]="secondPagination.currentPage"
              [totalPage]="secondPagination.totalSize"
              [pageSize]="secondPagination.pageSize"
              (changePage)="onSecondPageChange($event)"
            ></fn-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
